/* @nolint */
import { qtsp } from '@shared/tracking-qtsbinds';
import { getCookie, setCookie } from '@shared/cookie';
import { cookieBase } from 'server-data/flconfigs';

const cookieName = `${cookieBase}_COUNTRY_SELECT`;

function initcountrySelect() {
  const languageSiteMapping = {
    'freelancer.com.au': {
      url: 'www.freelancer.com.au',
      flag: 'australia',
      title: 'Looks like you are visiting from Australia',
      description:
        'Head to the Australian version of our site for a more localised experience',
      cta: 'Go to Freelancer Australia',
    },
    'freelancer.cn': {
      url: 'www.freelancer.cn',
      flag: 'china',
      title: '您正在中国访问本站',
      description: '您可以访问中文站点以获取更好的体验',
      cta: '访问Freelancer中国',
    },
    'freelancer.es': {
      url: 'www.freelancer.es',
      flag: 'spain',
      title: 'Parece que nos visitas desde España',
      description:
        'Dirígete a la versión Española de nuestro sitio para disfrutar una experiencia más localizada',
      cta: 'Ir a Freelancer España',
    },
    'br.freelancer.com': {
      url: 'br.freelancer.com',
      flag: 'brazil',
      title: 'Aparentemente você está nos visitando do Brasil',
      description:
        'Vá à versão brasileira do nosso site para uma experiência melhor regionalizada',
      cta: 'Ir à Freelancer Brasil',
    },
    'freelancer.mx': {
      url: 'www.freelancer.mx',
      flag: 'mexico',
      title: 'Parece que nos visitas desde México',
      description:
        'Dirígete a la versión Mexicana de nuestro sitio para disfrutar una experiencia más localizada',
      cta: 'Ir a Freelancer México',
    },
    'freelancer.com.pe': {
      url: 'www.freelancer.com.pe',
      flag: 'peru',
      title: 'Parece que nos visitas desde Perú',
      description:
        'Dirígete a la versión Peruana de nuestro sitio para disfrutar una experiencia más localizada',
      cta: 'Ir a Freelancer Perú',
    },
    'freelancer.ec': {
      url: 'www.freelancer.ec',
      flag: 'ecuador',
      title: 'Parece que nos visitas desde Ecuador',
      description:
        'Dirígete a la versión Ecuatoriana de nuestro sitio para disfrutar una experiencia más localizada',
      cta: 'Ir a Freelancer Ecuador',
    },
    'freelancer.com.co': {
      url: 'www.freelancer.com.co',
      flag: 'colombia',
      title: 'Parece que nos visitas desde Colombia',
      description:
        'Dirígete a la versión Colombiana de nuestro sitio para disfrutar una experiencia más localizada',
      cta: 'Ir a Freelancer Colombia',
    },
    'freelancer.uy': {
      url: 'www.freelancer.uy',
      flag: 'uruguay',
      title: 'Parece que nos visitas desde Uruguay',
      description:
        'Dirígete a la versión Uruguaya de nuestro sitio para disfrutar una experiencia más localizada',
      cta: 'Ir a Freelancer Uruguay',
    },
    'freelancer.com.ar': {
      url: 'www.freelancer.com.ar',
      flag: 'argentina',
      title: 'Parece que nos visitas desde Argentina',
      description:
        'Dirígete a la versión Argentina de nuestro sitio para disfrutar una experiencia más localizada',
      cta: 'Ir a Freelancer Argentina',
    },
    'freelancer.cl': {
      url: 'www.freelancer.cl',
      flag: 'chile',
      title: 'Parece que nos visitas desde Chile',
      description:
        'Dirígete a la versión Chilena de nuestro sitio para disfrutar una experiencia más localizada',
      cta: 'Ir a Freelancer Chile',
    },
    'freelancer.de': {
      url: 'www.freelancer.de',
      flag: 'germany',
      title: 'Scheinbar sucht du uns aus Deutschland auf',
      description:
        'Wechsel zur Deutschen  Version unserer Seite für eine bessere Nutzererfahrung',
      cta: 'Gehe zu Freelancer Deutschland',
    },
    'freelancer.in': {
      url: 'www.freelancer.in',
      flag: 'india',
      title: 'Looks like you are visiting from India',
      description:
        'Head to the Indian version of our site for a more localised experience',
      cta: 'Go to Freelancer India',
    },
  };
  const countrySelectEl = document.getElementById('PageHome-countrySelect');
  const queryString = window.location.search;
  const anchor = window.location.hash;
  const request = new XMLHttpRequest();
  request.open('GET', '/ajax/get-suitable-domain.php', true);

  request.onload = function() {
    if (request.status === 200) {
      const response = JSON.parse(request.responseText);
      const domain = response.name || '';
      if (typeof languageSiteMapping[domain] !== 'undefined') {
        const languageSetting = languageSiteMapping[domain];
        if (countrySelectEl && window.location.host.indexOf(domain) === -1) {
          qtsp.push({
            eventName: 'user_action',
            section: 'country-selector',
            subsection: domain,
            label: 'pop',
          });
          countrySelectEl
            .querySelector('#PageHome-countrySelect-flag')
            .classList.add(languageSetting.flag);
          countrySelectEl.querySelector(
            '#PageHome-countrySelect-title',
          ).textContent =
            languageSetting.title;
          countrySelectEl.querySelector(
            '#PageHome-countrySelect-description',
          ).textContent =
            languageSetting.description;
          countrySelectEl.querySelector(
            '#PageHome-countrySelect-cta',
          ).textContent =
            languageSetting.cta;
          countrySelectEl.classList.remove('is-hidden');

          countrySelectEl
            .querySelector('#PageHome-countrySelect-close')
            .addEventListener('click', () => {
              qtsp.push({
                eventName: 'user_action',
                section: 'country-selector',
                subsection: domain,
                label: 'close',
              });
              countrySelectEl.style.display = 'none';
              setCookie(cookieName, 'no-redirect', 7);
            });

          countrySelectEl
            .querySelector('#PageHome-countrySelect-cta-btn')
            .addEventListener('click', () => {
              qtsp.push({
                eventName: 'user_action',
                section: 'country-selector',
                subsection: domain,
                label: 'click',
              });
              window.location = `https://${
                languageSetting.url
              }/${queryString}${anchor}`;
            });
        }
      }
    }
  };

  request.onerror = function() {};

  request.send();
}

if (!getCookie(cookieName) && !getCookie('GETAFREE_AFPRO')) {
  initcountrySelect();
}
